import { ThemeDefinition } from 'vuetify';
import { base } from './base';

export const light: ThemeDefinition = {
  dark: false,
  colors: {
    ...base.colors,
    black: '#294053',

    /* Colors for the subjects */
    /* These are used by, for example, the exercise Match the pairs for the color of the header */
    green: '#62b878',
    teal: '#5dc7bb',
    'on-teal': '#ffffff',
    blue: '#56a4d7',
    gray: '#596a79',
    pink: '#be77a6',
    yellow: '#cf9d58',
    purple: '#8169af',
    darkblue: '#124c8f',
    orange: '#ef7b47',
    gold: '#F3BF39',
    highlighterred: '#E85656',
    hkk: '#9ACD48',
    ft: '#3C92AA',
    sl: '#C6684D',
    blush: '#D37777',
    sybaritegreen: '#89CAAD',
  },
};
